module.exports = function() {
	return new Worker(__webpack_public_path__ + "main-worker.3db1f43a4658d383812e.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader?name=main-worker.[hash].js!./src/main/web/js/app/main-worker.js
// module id = 269
// module chunks = 5